import ContactMessage from '@business/messaging/ContactMessage';
import config from '@config';
import { useTranslate } from '@xFrame4/components/Hooks';
import FieldEditor, { FieldEditorType } from '@xFrame4/components/FieldEditor';
import { useUpdateEntityFields } from '@xFrame4/components/Hooks';
import { FormEvent, FunctionComponent, useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import ReCAPTCHA from "react-google-recaptcha";

interface ContactFormProps
{

}

const ContactForm: FunctionComponent<ContactFormProps> = (props) =>
{
    const t = useTranslate();
    const [validated, setValidated] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [messageSent, setMessageSent] = useState<boolean>(false);
    const [contactMessage, setContactMessage, updateEntityField] = useUpdateEntityFields<ContactMessage>();
    const [captchaWasSuccesful, setCaptchaWasSuccesful] = useState<boolean>(false);

    /** Create new entity */
    useEffect(() => {
        setContactMessage(new ContactMessage());
    }, [])

    /** Form validate */
    const onValidate = () => 
    {
        return captchaWasSuccesful;
    }

    /** Form submit */
    const onSubmit = (event: FormEvent<HTMLFormElement>) =>
    {
        event.preventDefault();
        event.stopPropagation();

        // Validate
        const form = event.currentTarget;
        if (form.checkValidity() === true) // Standard validation
        {
            let isValid = true;
            isValid = onValidate(); // Additional custom validation

            // Form is valid: save
            if (isValid) save();
        }

        setValidated(true);
    };

    /** 
     * Captcha change: means that the user succesfully completed the challenge
     * https://www.npmjs.com/package/react-google-recaptcha
     */
    const onCaptchaChange = (value: any) => 
    {
        setCaptchaWasSuccesful(true);
    };

    /** Save the form data. */
    const save = async () =>
    {
        setIsSaving(true);
        
        try
        {
            if (contactMessage) setMessageSent(await contactMessage.save())
            setIsSaving(false);
        }
        catch(error)
        {
            setIsSaving(false);
        }
    };

    /** Render */
    return (
        <div className="contact-form">
            {messageSent == false &&
            <Form noValidate validated={validated} onSubmit={(event) => onSubmit(event)}>
                <FieldEditor 
                    type={FieldEditorType.Text}
                    field="name"
                    label={t('CONTACT_NAME') + ' *'}
                    placeholder={t('PLACEHOLDER_CONTACT_NAME')}
                    isRequired={true}
                    className="contact-form-field mb-4"
                    value={contactMessage?.name}
                    onValueChanged={(field, value) => updateEntityField(field, value)}
                />

                <FieldEditor 
                    type={FieldEditorType.Text}
                    field="email"
                    label={t('CONTACT_EMAIL') + ' *'}
                    placeholder={t('PLACEHOLDER_CONTACT_EMAIL')}
                    isRequired={true}
                    className="contact-form-field mb-4"
                    value={contactMessage?.email}
                    onValueChanged={(field, value) => updateEntityField(field, value)}
                />

                <FieldEditor 
                    type={FieldEditorType.Textarea}
                    field="message"
                    label={t('CONTACT_MESSAGE') + ' *'}
                    placeholder={t('PLACEHOLDER_CONTACT_MESSAGE')}
                    isRequired={true}
                    className="contact-form-field mb-4"
                    value={contactMessage?.message}
                    onValueChanged={(field, value) => updateEntityField(field, value)}
                />

                <ReCAPTCHA
                    sitekey={config.googleCaptchaKey}
                    onChange={onCaptchaChange}
                    className="my-3"
                />

                <Button
                    variant="dark"
                    type="submit"
                    disabled={isSaving}
                    className="rounded px-4 py-2"
                >
                    {t('CONTACT_SUBMIT')}
                </Button>
            </Form>
            }

            {messageSent &&
            <div className="contact-form-thank-you ">
                <div className="alert alert-primary" role="alert">
                {t('CONTACT_FORM_THANK_YOU')}
                </div>
            </div>
            }
        </div>
    );
}

export default ContactForm;